import React, { Component } from 'react'

class Event extends Component {
    render() {
        return(<li><a target="_blank" rel="noopener noreferrer" href={ `https://facebook.com/events/${this.props.data.id}` }>{ this.props.data.name }</a></li>)
    }
}

export default class Events extends Component {
    constructor() {
        super()
        this.state = { events: [] }
    }
    componentDidMount() {
        fetch('https://graph.facebook.com/zweitehessischegebirgsmarine/events?access_token=1180182835369971|l-gJz8Vtuk2eC4woRZpUyrmPe4Y')
        .then(response => response.json())
        .then(json => {
            let events = json.data.filter(e => Date.now() < new Date(e.start_time))
            this.setState({ events })
        })
    }
    render() {
        let events = this.state.events.map(e => <Event key={ e.id } data={ e } />)
        if(events.length > 0) {
            return(<div><h3>Nächste Termine</h3><ul>{ events }</ul></div>)
        }
        return null
    }
}



// WEBPACK FOOTER //
// ./src/Events.js